import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const auth = {
  register: (data) => api.post("/auth/register", data),
  login: (data) => api.post("/auth/login", data),
  me: () => api.get("/auth/me"),
  forgotPassword: (email) => api.post("/auth/forgot-password", { email }),
  resetPassword: (token, new_password) => api.post("/auth/reset-password", { token, new_password }),
  changePassword: (current_password, new_password) => api.post("/auth/change-password", { current_password, new_password }),
};

export const diagrams = {
  list: () => api.get("/diagrams"),
  get: (id) => api.get(`/diagrams/${id}`),
  create: (data) => api.post("/diagrams", data),
  update: (id, data) => api.put(`/diagrams/${id}`, data),
  delete: (id) => api.delete(`/diagrams/${id}`),
  fork: (id) => api.post(`/diagrams/${id}/fork`),
  generateFromSource: (data) => api.post("/diagrams/generate-from-source", data),
  getAnnotations: (id) => api.get(`/diagrams/${id}/annotations`),
  updateAnnotations: (id, data) => api.put(`/diagrams/${id}/annotations`, data),
};

export const gallery = {
  list: () => api.get("/gallery"),
};

export const ai = {
  generate: (data) => api.post("/ai/generate", data),
  explain: (data) => api.post("/ai/explain", data),
  improve: (data) => api.post("/ai/improve", data),
};

export const templates = {
  list: () => api.get("/templates"),
};

export const share = {
  get: (id) => api.get(`/share/${id}`),
};

export const apiKeys = {
  get: () => api.get("/users/api-key"),
  generate: () => api.post("/users/api-key"),
  revoke: () => api.delete("/users/api-key"),
};

export const subscriptions = {
  getPlans: () => api.get("/plans"),
  getSubscription: () => api.get("/subscription"),
  createCheckout: (data) => api.post("/checkout/session", data),
  getCheckoutStatus: (sessionId) => api.get(`/checkout/status/${sessionId}`),
  contactEnterprise: (data) => api.post("/contact/enterprise", data),
};

export const settings = {
  get: () => api.get("/settings"),
};

export const admin = {
  getPlans: () => api.get("/admin/plans"),
  updatePlan: (planId, data) => api.put(`/admin/plans/${planId}`, data),
  getSettings: () => api.get("/admin/settings"),
  updateSettings: (data) => api.put("/admin/settings", data),
  getUsers: (skip = 0, limit = 50) => api.get(`/admin/users?skip=${skip}&limit=${limit}`),
  getUser: (userId) => api.get(`/admin/users/${userId}`),
  toggleAdmin: (userId) => api.put(`/admin/users/${userId}/admin`),
  updateUserSubscription: (userId, planId) => api.put(`/admin/users/${userId}/subscription?plan_id=${planId}`),
  resetUserPassword: (userId, new_password) => api.put(`/admin/users/${userId}/password`, { new_password }),
  getEnterpriseContacts: () => api.get("/admin/enterprise-contacts"),
  getStats: () => api.get("/admin/stats"),
  getAuditLog: (skip = 0, limit = 50) => api.get(`/admin/audit-log?skip=${skip}&limit=${limit}`),
  getStripeSettings: () => api.get("/admin/stripe-settings"),
  updateStripeSettings: (data) => api.post("/admin/stripe-settings", data),
};

export default api;
